<div class="ui-g ui-fluid">
    <div class="ui-g-12" style="margin: 8% 20%;">
        <div class="ui-g-12">
            <img src="../../assets/images/new-icons/wait.png" style="display: block; margin: auto;">
        </div>
        <p style="font-family: poppins; font-size: 24px; font-weight: 500; text-align: center;">Esperando que el Doctor(a) acepte su llamada.</p>

    </div>
</div>

